export default "__VITE_ASSET__DEa$rs1O__"